

exports.__esModule = true;
var _submitButtonGuestTextKeyMap = {
    commit: 'common.payLabel',
    notCommit: 'common.continueLabel'
};

var _submitButtonSignupTextKeyMap = {
    commit: 'common.createAccountAndPayNow',
    notCommit: 'common.agreeAndCreateAccount'
};

var submitButtonTextKeyMap = {
    signup: {
        US: _submitButtonSignupTextKeyMap,
        ROW: {
            commit: 'common.agreeAndPay',
            notCommit: 'common.agreeAndContinue'
        }
    },
    pomaSignup: {
        US: _submitButtonSignupTextKeyMap,
        ROW: {
            commit: 'common.agreeAndPayNowPoma',
            notCommit: 'common.agreeAndContinue'
        }
    },
    guest: {
        US: _submitButtonGuestTextKeyMap,
        ROW: _submitButtonGuestTextKeyMap
    }
};

exports['default'] = {
    submitButtonTextKeyMap: submitButtonTextKeyMap
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest/constants/constants.js
// module id = ./components/xo-guest-components/src/guest/constants/constants.js
// module chunks = 1